import script from "./WebinarList.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebinarList.vue?vue&type=script&lang=ts&setup=true"

import "./WebinarList.vue?vue&type=style&index=0&id=5f18c420&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f18c420"]])

export default __exports__